import { create } from 'zustand';

interface AuthState {
	name: string;
	pk: string;
	setPk: (pk: string) => void;
	setName: (name: string) => void;
	clearValues: () => void;
}

const getInitialValues = (): { name: string; pk: string } => {
	try {
		const authData = localStorage.getItem('auth');
		return authData ? JSON.parse(authData) : { name: '', pk: '' };
	} catch (error) {
		console.error('Failed to parse auth data from localStorage:', error);
		return { name: '', pk: '' };
	}
};

export const useAuthStore = create<AuthState>((set, get) => ({
	...getInitialValues(),

	setName: (name) => {
		set({ name });
		const { pk } = get();
		localStorage.setItem('auth', JSON.stringify({ name, pk }));
	},

	setPk: (pk) => {
		set({ pk });
		const { name } = get();
		localStorage.setItem('auth', JSON.stringify({ name, pk }));
	},

	clearValues: () => {
		set({ name: '', pk: '' });
		localStorage.removeItem('auth');
	},
}));
